module.exports = __webpack_public_path__ + "0c7ff3ffe0db94aa8ee988b0c540bb7b.pdf";